import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import { useAuthContext } from '../../context/authContext';

/**
 * Las campañas de avisos, con la audiencia calculada en el momento.
 *
 * Los números no se guardan: se preguntan cada vez que se abre la pantalla,
 * porque "a cuántos les toca" cambia cada vez que un cliente entra a elegir.
 */
export default function useCampanas() {
  const { token, baseUrl } = useAuthContext();

  const [campanas, setCampanas] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(() => {
    setError('');
    return axios.get(`${baseUrl}admin/avisos/campanas`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => setCampanas(r.data?.data ?? r.data ?? []))
      .catch((e) => {
        const estado = e?.response?.status;
        setError(estado === 401 || estado === 403
          ? 'Tu sesión no tiene permiso para ver los avisos.'
          : 'No pudimos cargar las campañas. Intenta de nuevo en un momento.');
      })
      .finally(() => setCargando(false));
  }, [token, baseUrl]);

  useEffect(() => { cargar(); }, [cargar]);

  const enviar = useCallback((clave) =>
    axios.post(`${baseUrl}admin/avisos/campanas/${clave}/enviar`, null, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.data?.data ?? r.data), [token, baseUrl]);

  return { campanas, cargando, error, recargar: cargar, enviar };
}
